<template>
  <div id="app">

    <vue-progress-bar/>

    <Navbar :bare="showBare"/>

    <div class="container-xl">

      <transition name="slide-fade" v-if="!showBare">
        <Sidebar v-if='env.menu'/>
      </transition>

      <main>
        <router-view/>
      </main>

    </div>

  </div>
</template>

<script>
import Navbar from './components/common/Navbar.vue'
import Sidebar from './components/common/Sidebar.vue'

import {
  mapState
} from 'vuex'

export default {
  name: 'app',
  components: {
    Navbar, Sidebar
  },
  data () {
    return {
      showBare: false
    }
  },
  computed: {
    ...mapState(['env'])
  },
  created () {
    this.showBare = !this.$route.meta.requiresAuth
  },
  watch: {
    '$route' (a) {
      this.showBare = !a.meta.requiresAuth
    }
  }
}
</script>

<style lang="stylus" src="./styles/App.styl"/>



// WEBPACK FOOTER //
// src/App.vue